import React, { FC, useEffect, useMemo } from "react";
import "./confirm.scss";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../store";
import { useNavigate } from "react-router";
import { ROUTES } from "../../../../../constants/path";
import { toggleTicketModal } from "../../../../../store/ticketBooking/action";
import { generateMailApi, sendMailApi } from "../../../../../services/payment";
import { COUNTRY } from "../../../../../constants/app";
import { IMAGE_URL_CONFIG } from "../../../../../constants/url";

interface IRefundConfirmationProps {
  onCloseModal: () => void;
}

const RefundConfirmation: FC<IRefundConfirmationProps> = ({ onCloseModal }) => {
  const { refundDetails, countryId } = useSelector((state: RootState) => ({
    countryId: state.applicationReducer.countryId,
    refundDetails: state.ticketBookingReducer.refundDetails
  }));

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onBack = () => {
    dispatch(toggleTicketModal(false));
    navigate(`/${ROUTES.MOVIES}/${ROUTES.NOW_SHOWING}`)
  }

  const ticketCount = useMemo(() => {
    return refundDetails?.refundData?.ticketData?.filter((v: any) => v.refundstatus !== 'refund' && !refundDetails?.refundItems.ticketInput?.find((t: any) => v.Id == t.RowId)).length
  }, [refundDetails])

  const concessionCount = useMemo(() => {
    return refundDetails?.refundData?.concessionData.filter((v: any) => v.refundstatus !== 'refund' && !refundDetails?.refundItems?.concessionInput?.find((c: any) => v.Id == c.RowId)).length
  }, [refundDetails])

  const sendTicketConfirmation = async () => {
    const payload = {
      id: refundDetails?.saleId,
      countryId: countryId,
      templateName: "E-Tix Confirmation",
      requestType: 'refund',
    };
    await generateMailApi(payload)
  };

  useEffect(() => {
    if (countryId && refundDetails?.refundType === 'partial' && refundDetails?.saleId && refundDetails?.saleId && (ticketCount > 0 || concessionCount > 0)) {
      sendTicketConfirmation()
    }
  }, [countryId, refundDetails])



  const sendmail = async () => {
    sendMailApi({
      countryId,
      templateName: "Ticket refund confirmation",
      to: refundDetails?.refundData?.email,
      ticketConfirmationNumber: refundDetails?.refundData?.ticketConfirmationNumber,
      bookingFee: refundDetails?.bookingFee,
      tickets: refundDetails?.refundItems.ticketInput?.map((v: any) => {
        const tk = refundDetails?.refundData?.ticketData?.find((t: any) => t.Id == v.RowId)
        return tk ? tk : {}
      }),
      concessions: refundDetails?.refundItems?.concessionInput?.map((v: any) => {
        const con = refundDetails?.refundData?.concessionData?.find((c: any) => c.Id == v.RowId)
        return con ? con : {}
      }),
      amount: countryId === COUNTRY.NZ ? refundDetails?.payload?.amount : (refundDetails?.payload?.amount / 100).toFixed(2),
      saleId: refundDetails?.saleId,
      cinemaId: refundDetails?.refundData?.cinemaId
    })
    if (countryId && refundDetails?.refundType === 'partial' && refundDetails?.saleId && (ticketCount > 0 || concessionCount > 0)) {
      sendTicketConfirmation()
    }
  }

  return (
    <div className="refund-confirmation-wrapper">

      {
        refundDetails && refundDetails?.refundType === 'partial'  && (ticketCount > 0 || concessionCount > 0)?
        <div className="refund-details">
          <p className="title">You’ve been sent the following:</p>
          <div className="mail-details">
            <div className="mail">
              <img
                  src={
                    IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH +
                    "tick_green.svg"
                  }
                  alt="icon"
                />
                <p className="mail-type">Refund receipt.</p>
            </div>
              <div className="mail">
                <img
                    src={
                      IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH +
                      "tick_green.svg"
                    }
                    alt="icon"
                  />
                  <p className="mail-type">New eTicket with new booking number.</p>
              </div>
          </div>
        </div>
        :        
        <div className="refund-details">
          <p className="title">You’ve been sent a refund receipt.</p>
        </div>
      }

      <div className="email-row">
        <span className="label">Emailed To:</span>
        <span className="email">{refundDetails?.refundData?.email}</span>
        <button
          type="button"
          className="ref-btn btn gray_btn"
          onClick={sendmail}
        >
          Resend
        </button>
      </div>

      <div className="footer-note">
        <p>Your refund will be paid to the original payment method.<br />
          Please allow up to 72 business hours for the funds to reflect in your account</p>
      </div>

      <div className={`movie_footer_btn_el col-md-12 ml-auto`}>
        <div className="movie_button_wrap justify-content-end">
          <button
            type="button"
            className="ref-btn btn black_btn"
            onClick={onBack}
          >
            Go to movies Home Page
          </button>
        </div>
      </div>
    </div>
  );
};

export default RefundConfirmation;
